import React from 'react';
import CheckIcon from 'react-icons/lib/md/info';

const ManifestDeleteInfo = ({manifestCount}) => {
    const manifestText = (manifestCount > 1) ? ' manifests' : ' manifest';
    return (
        <div className={'text-center'}>
            <CheckIcon size="70"/>
            <h4>Are you sure you want to delete {manifestCount} {manifestText} ?</h4>
        </div>
    );
};

export default ManifestDeleteInfo;


// WEBPACK FOOTER //
// ./src/views/search/info-manifest-delete.js